import {Page} from "../flair/Page.es6";

Page.startsWith("/apply/").go(function() {
	const mainForm = document.querySelector("form.main");
	const navForm = document.querySelector("form.nav");
	let currentElement = null;
	let timeoutSave = null;
	let organisation = document.querySelector("main>section").dataset["organisation"];
	let parser = new DOMParser();

	if(!mainForm) {
		return;
	}

// Accessibility "skip" button:
	let skipButton = mainForm.querySelector("button[name=do][value=skip-section]");
	if(skipButton) {
		skipButton.addEventListener("click", e => {
			let optOutRadio = mainForm.querySelector("input.opt-in-out.conditional-opt-out");
			if(optOutRadio) {
				optOutRadio.checked = true;
				optOutRadio.dispatchEvent(new Event("change"));
			}
		});
	}

// Toggle the conditional sections of forms when the conditional checkbox changes.
	mainForm.querySelectorAll(".conditional").forEach(input => {
		input.addEventListener("change", e => {
			mainForm.querySelectorAll(".on-conditional-container").forEach(occ => {
				let show = null;
				let conditional = input.dataset["conditional"];
				let containerConditional = occ.dataset["onConditional"];

				let isConditionalTrue = input.checked;
				if(input.classList.contains("conditional-opt-out")) {
					isConditionalTrue = !isConditionalTrue;
				}

				if(containerConditional) {
					if(conditional === containerConditional) {
						show = isConditionalTrue;
					}
				}
				else {
					if(!conditional) {
						show = isConditionalTrue;
					}
				}

				if(show !== null) {
					if(show) {
						occ.classList.add("show");
					}
					else {
						occ.classList.remove("show");
						let conditionalEl = occ.querySelector(".on-conditional");
						if(conditionalEl) {
							if(conditionalEl instanceof HTMLTextAreaElement) {
								conditionalEl.innerHTML = "";
								mainForm.dispatchEvent(new CustomEvent("change"));
							}
						}
					}

					occ.querySelectorAll("textarea").forEach(textarea => {
						textarea.required = show;
					});
				}
			});
		});
		input.dispatchEvent(new CustomEvent("change"));
	});

// The save button will be automatically triggered on every input's blur.
// It is only in the HTML for screen readers.
	mainForm.querySelector("div.actions").style.display = "none";

	/**
	 * When each element changes, save the form's contents. This is also
	 * done when the next button is pressed - belt and braces!
	 */
	mainForm.addEventListener("change", event => {
		currentElement = event.target;
		if(currentElement instanceof HTMLInputElement
		&& currentElement.type !== "file") {
			currentElement.value = currentElement.value.trim();
		}

		let container = event.target.closest(".input-container");
		let fileListEl = null;
		if(container) {
			fileListEl = container.querySelector(".file-list");
		}

		save(saveComplete);
	});

	mainForm.addEventListener("click", function clickToRemoveUpload(e) {
		let button = e.target;
		if(!(button instanceof HTMLButtonElement)) {
			button = button.closest("button");
		}
		if(!button) {
			return;
		}

		let fileList = button.closest(".file-list");
		if(!fileList) {
			return;
		}

		e.preventDefault();

		let fileName = button.querySelector("span").textContent;
		if(confirm(`Are you sure you want to remove file ${fileName} ?`)) {
			let formData = new FormData();
			formData.append(button.name, button.value);

			fetch(location.href, {
				method: "POST",
				credentials: "same-origin",
				body: formData
			}).then(response => {
				if(!response.ok) {
					console.log("Response code", response.status);
					return;
				}

				return response.text();
			}).then(html => {
				let newDocument = parser.parseFromString(html, "text/html");
				let currentFileList = document.querySelectorAll(".file-list");
				newDocument.querySelectorAll(".file-list").forEach((element, index) => {
					currentFileList[index].replaceWith(element);
				});
			});
		}
	});

	/**
	 * When the next page button is clicked, first it should call save(),
	 * and when the save request completes, the next button will be clicked
	 * again, this time programmatically. Because the user doesn't "really"
	 * click the button for the second time, it will not be e.isTrusted,
	 * so the form will submit as usual.
	 */
	document.querySelectorAll("button[name=do][value=next-page],button[name=do][value=submit-application]").forEach(button => {
		button.addEventListener("click", e => {
			if(mainForm.checkValidity()) {
				if(window.scrollY > mainForm.parentElement.offsetTop) {
					scrollTo({
						top: mainForm.parentElement.offsetTop,
						behavior: "smooth",
					});
				}
			}
			else {
				e.preventDefault();
				mainForm.reportValidity();
				return;
			}

			navForm.classList.add("loading");
			mainForm.classList.add("loading");

			if(timeoutSave) {
				clearTimeout(timeoutSave);
				timeoutSave = null;
			}

			if(!e.isTrusted) {
				return;
			}
			e.preventDefault();

			save(response => {
				if(mainForm.checkValidity()) {
					if(button.classList.contains("clicked")) {
						navForm.classList.remove("loading");
						mainForm.classList.remove("loading");
					}
					else {
						button.click();
					}
				}
				else {
					let validationMessageShown = false;
					mainForm.querySelectorAll("[name]").forEach(input => {
						if(!input.checkValidity() && !validationMessageShown) {
							input.parentElement.scrollIntoView({
								behavior: "smooth"
							});
							validationMessageShown = true;
						}
					});

					setTimeout(() => {
						mainForm.reportValidity();
						mainForm.classList.remove("loading");
						navForm.classList.remove("loading");
					}, 500);
				}
			});
		});
	});

	/**
	 * callback will be provided the Response object from the fetch request.
	 */
	function save(callback) {
		let saveTimeoutDuration = 1000;
		let formData = new FormData(mainForm);
		formData.append("do", "save");

		if(document.activeElement instanceof HTMLButtonElement) {
			saveTimeoutDuration = 25;
		}

		mainForm.querySelectorAll("[type=checkbox]").forEach(input => {
			formData.append(input.name, input.checked ? "on" : "");
		});

		let fileListEl = null;
		if(currentElement) {
			let container = currentElement.closest(".input-container");
			if(container) {
				fileListEl = container.querySelector(".file-list");
			}
		}

		if(fileListEl && currentElement.type === "file") {
			for(const file of currentElement.files) {
				if(file.type === "image/heic" || file.type === "image/heif") {
					if(!currentElement.dataset.heicDone) {
						return;
					}
				}
			}

			fileListEl.classList.add("processing");

			for(let i = 0, len = currentElement.files.length; i < len; i++) {
				let file = currentElement.files[i];
				let outerSpan = document.createElement("span");
				let innerSpan = document.createElement("span");
				innerSpan.textContent = file.name;
				let img = document.createElement("img");
				img.src = "/asset/icon/file-alt-solid.svg";
				outerSpan.appendChild(innerSpan);
				outerSpan.appendChild(img);

				let insertBefore = null;
				Array.from(fileListEl.children).forEach(child => {
					if(!insertBefore) {
						if(file.name.localeCompare(child.querySelector("span").textContent) < 0) {
							insertBefore = child;
						}
					}
				});
				fileListEl.insertBefore(outerSpan, insertBefore);

				if(file.type.startsWith("image/")) {
					let reader = new FileReader();
					reader.onload = function(event) {
						img.src = event.target.result; // Set src to base64 encoded URL
					};
					reader.readAsDataURL(file);
				}
			}
		}

		if(timeoutSave) {
			clearTimeout(timeoutSave);
			timeoutSave = null;
		}
		timeoutSave = setTimeout(() => {
			fetch(location.href, {
				method: "POST",
				body: formData,
				credentials: "same-origin"
			}).then(callback);
			timeoutSave = null;
		}, saveTimeoutDuration);
	}

	function saveComplete(response) {
		navForm.classList.remove("loading");

		document.querySelectorAll(".file-list").forEach(fileListEl => {
			fileListEl.classList.remove("processing");
			fileListEl.classList.add("completed");
		});

		if(!response.ok) {
			console.log("Response code", response.status);
		}

		response.text().then(html => {
			let newDocument = parser.parseFromString(html, "text/html");
			let currentFileList = document.querySelectorAll(".file-list");
			newDocument.querySelectorAll(".file-list").forEach((element, index) => {
				currentFileList[index].replaceWith(element);
			});
		});
	}

	let heicScript = document.createElement("script");
	heicScript.src = "https://cdn.jsdelivr.net/npm/heic2any";
	heicScript.addEventListener("load", heicLoad)
	document.head.appendChild(heicScript);

	function heicLoad() {
		if(!("heic2any" in window)) {
			console.log("No HEIC conversion support");
			return;
		}

		document.querySelectorAll("input[type='file']").forEach(input => {
			input.addEventListener("change", heicInputChange);
		});
	}

	async function heicInputChange(e) {
		if(!("heic2any" in window)) {
			/** @type {function({blob: Blob}): Promise<Blob>} window.heic2any */
			window.heic2any = undefined;
		}

		const dataTransfer = new DataTransfer();
		let changedFileList = false;
		for(const file of e.target.files) {
			if(file.type !== "image/heic" && file.type !== "image/heif") {
				dataTransfer.items.add(file);
				continue;
			}

			try {
				const heicBlob = await heic2any({
					blob: file,
					toType: "image/jpeg",
				});
				const jpgFile = new File(
					[heicBlob],
					file.name + ".jpg", {
						type: "image/jpeg"
					}
				);

				dataTransfer.items.add(jpgFile);
				changedFileList = true;
			} catch(error) {
				dataTransfer.items.add(file);
			}
		}

		if(changedFileList) {
			console.log(e.target.files);
			e.target.files = dataTransfer.files;
			console.log(e.target.files);
			e.target.dataset.heicDone = "true";
			save(saveComplete);
		}
	}
});
